import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "team-card card" }

import {onMounted, ref} from "vue";
	import FetchOptions from "../interfaces/FetchOptions";
	import {FetchData} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TeamCard',
  props: {
    team: {}
  },
  emits: [
		'deleteTeam'
	],
  setup(__props: any, { emit: __emit }) {

	const team = ref({});

	const props = __props;

	const emit = __emit;

	onMounted(() => {
		team.value = JSON.parse(JSON.stringify(props.team));
	});

	async function saveTeam() {
		const body = team.value;
		delete body.drivers;

		console.log(body);

		if(body.id !== undefined) {
			const options: FetchOptions = {
				method: 'PATCH',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('teams/' + team.value.id, options);
			if(!data.isError)
				emitter.emit('showMessage', {message: 'Team opgeslagen', header: 'Gelukt'});
		}
		else {
			const options: FetchOptions = {
				method: 'POST',
				headers: {
					"Content-Type": 'application/json'
				},
				body: JSON.stringify(body)
			};

			const data = await FetchData('teams', options);
			if(!data.isError) {
				team.value = data.data;
				console.log(data.data);
				emitter.emit('showMessage', {message: 'Team toegevoegd', header: 'Gelukt'});
			}
		}
	}

	function deleteTeam() {
		emit('deleteTeam', team.value);
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((team.value.name) = $event))
    }, null, 512), [
      [_vModelText, team.value.name]
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: deleteTeam
    }, " Verwijderen "),
    _createElementVNode("button", {
      class: "content-box",
      onClick: saveTeam
    }, " Opslaan ")
  ]))
}
}

})